import { render, staticRenderFns } from "./DashboardCollectionV2.vue?vue&type=template&id=c4f3bcac&"
import script from "./DashboardCollectionV2.vue?vue&type=script&lang=js&"
export * from "./DashboardCollectionV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports